// import { isEmpty } from 'lodash';
import { FC } from 'react';
import Link from 'next/link';
import styles from './Previous.module.scss';

interface IPrevious {
  currentPageNo?: number;
  postName?: string;
}

const Previous: FC<IPrevious> = ({ currentPageNo, postName }) => {
  if (
    !currentPageNo
    // || isEmpty( postName )
  ) {
    return null;
  }

  // If you are on the first page, don't show previous link.
  if (0 === currentPageNo - 1) {
    return null;
  }

  const paginationLink = `/${postName}${currentPageNo - 1}`;

  return (
    <Link prefetch={false} className={styles.prev} href={paginationLink}>
      &lt;
    </Link>
  );
};

export default Previous;
